<template>
  <DialogTemplateToolkit
    v-if="!listLoading && reports.length"
    :dialog="dialog"
    :title="$t('Common.Reports')"
    @close="close">
    <sButton
      slot="first_btn"
      data-qa="btn-organization-reports-download"
      :disabled="!canGenerate"
      :loading="generating"
      @click="apply">
      {{ $t('Tenders.Download') }}
    </sButton>
    <template #activator-btn>
      <TooltipedBtn
        data-qa="btn-organization-reports"
        :disabled="disabled"
        icon="docs"
        :small-btn="true"
        :text="$t('Common.Reports')"
        :texted="$vuetify.breakpoint.lgAndUp"
        @click="open"/>
    </template>
    <template #card-text>
      <v-card-text class="h6-text black--text pa-0">
        <sSelect
          class="width-100 mt-1"
          clearable
          data-qa="organization-reports-select"
          filterable
          :placeholder="$t('Common.SelectReport')"
          :value="selectedReportId"
          @update:value="selectedReportId = $event">
          <sOption
            v-for="report in reports"
            :key="report.id"
            :data-qa="`organization-report-${report.id}`"
            :label="report.name"
            :value="report.id"/>
        </sSelect>
        <sAlert
          v-if="selectedReport && !publishedPeriod"
          class="mt-3 error--text"
          small
          type="error">
          {{ $t('Common.SetPublishedDateFilterHint') }}
        </sAlert>
        <sAlert
          v-if="selectedReport && selectedReport.comment"
          class="mt-3"
          small>
          {{ selectedReport.comment }}
        </sAlert>
      </v-card-text>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
import { debounce } from 'toolkit/utils/util'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'

const api = new SmarttenderApi()

export default {
  name: 'organizationReportsDialog',
  data() {
    return {
      dialog: false,
      listLoading: true,
      generating: false,
      reports: [],
      selectedReportId: null,
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.generating = false
      this.dialog = false
      this.selectedReportId = this.reports[0]?.id ?? null
    },
    apply: debounce(async function () {
      if (!this.canGenerate) {
        return
      }
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', this.$t('Common.Reports'))
        return
      }
      this.generating = true
      // Ключ детермінований (звіт+організація+період+департаменти), а не Date.now() — щоб повторний
      // запуск того самого звіту з тими самими фільтрами оновлював існуючий рядок у віджеті
      // завантажень, а не плодив дублі. Інші фільтри — свідомо інший ключ (окремий рядок),
      // це відповідає вимозі бекенду підтримувати паралельні генерації з різними фільтрами.
      const departmentsKey = this.departmentIds.length ? `-d${this.departmentIds.join('.')}` : ''
      const key = `organization-report-${this.selectedReport.id}-${this.currentOrganization.organizationItId}-${this.publishedPeriod.from}-${this.publishedPeriod.to}${departmentsKey}`
      await this.$notifier.generateOrganizationReportFile(
        this.selectedReport,
        this.currentOrganization.organizationItId,
        {
          publishedDateFrom: this.publishedPeriod.from,
          publishedDateTo: this.publishedPeriod.to,
          ...(this.departmentIds.length && { departmentIds: this.departmentIds }),
        },
        key
      )
      this.close()
    }, 250),
    async getReports() {
      // smarttenderApi.js ковтає помилку запиту і резолвить undefined — це відрізняємо
      // від null, який бек повертає, коли організації не налаштовано жодного звіту (не помилка).
      const res = await api.getCommonOrganizationReports()
      if (res === undefined) {
        this.$notice.error({
          message: this.$t('Common.FailedLoadReportsList'),
        })
      } else {
        this.reports = res || []
        this.selectedReportId = this.reports[0]?.id ?? null
      }
      this.listLoading = false
    }
  },
  computed: {
    ...mapGetters({ currentOrganization: 'getCurrentOrganization' }),
    ...mapGetters('notification', ['isActiveSignalR']),
    departmentIds() {
      if (!this.growthBook?.useOrganizationReportDepartmentFilter) {
        return []
      }
      return [...new Set(this.filters?.containsFilter?.departmentIds || [])]
    },
    selectedReport() {
      return this.reports.find(report => report.id === this.selectedReportId) || null
    },
    publishedPeriod() {
      return this.filters?.containsFilter?.publication || null
    },
    canGenerate() {
      return !!this.selectedReportId && !!this.publishedPeriod?.from && !!this.publishedPeriod?.to
    },
  },
  components: {
    TooltipedBtn,
    DialogTemplateToolkit,
  },
  async created() {
    await this.getReports()
  },
  watch: {
    currentOrganization( ) {
      this.getReports()
    },
  },
  props: {
    filters: Object,
    disabled: Boolean,
  },
}
</script>
